// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActionTextLinkController from "./action_text_link_controller"
application.register("action-text-link", ActionTextLinkController)

import ActiveController from "./active_controller"
application.register("active", ActiveController)

import Admin__ChoicesController from "./admin/choices_controller"
application.register("admin--choices", Admin__ChoicesController)

import Admin__InternalChatMessageController from "./admin/internal_chat_message_controller"
application.register("admin--internal-chat-message", Admin__InternalChatMessageController)

import Admin__NoUiSliderController from "./admin/no_ui_slider_controller"
application.register("admin--no-ui-slider", Admin__NoUiSliderController)

import Admin__SidebarController from "./admin/sidebar_controller"
application.register("admin--sidebar", Admin__SidebarController)

import Admin__VocBulkOpsController from "./admin/voc_bulk_ops_controller"
application.register("admin--voc-bulk-ops", Admin__VocBulkOpsController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CloneController from "./clone_controller"
application.register("clone", CloneController)

import CloudflareTurnstileController from "./cloudflare_turnstile_controller"
application.register("cloudflare-turnstile", CloudflareTurnstileController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import DarkHeaderController from "./dark_header_controller"
application.register("dark-header", DarkHeaderController)

import DarkModeController from "./dark_mode_controller"
application.register("dark-mode", DarkModeController)

import DatatableController from "./datatable_controller"
application.register("datatable", DatatableController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import DatePickerInlineController from "./date_picker_inline_controller"
application.register("date-picker-inline", DatePickerInlineController)

import DateRangePickerController from "./date_range_picker_controller"
application.register("date-range-picker", DateRangePickerController)

import ElementController from "./element_controller"
application.register("element", ElementController)

import GlightboxController from "./glightbox_controller"
application.register("glightbox", GlightboxController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import RadioLinkToController from "./radio_link_to_controller"
application.register("radio-link-to", RadioLinkToController)

import ScrollTopController from "./scroll_top_controller"
application.register("scroll-top", ScrollTopController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SelectLinkToController from "./select_link_to_controller"
application.register("select-link-to", SelectLinkToController)

import SingleSelectorController from "./single_selector_controller"
application.register("single-selector", SingleSelectorController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)

import TagsController from "./tags_controller"
application.register("tags", TagsController)

import TemplatePartsController from "./template_parts_controller"
application.register("template-parts", TemplatePartsController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TocController from "./toc_controller"
application.register("toc", TocController)

import TooltipsController from "./tooltips_controller"
application.register("tooltips", TooltipsController)

import TrixArticlesController from "./trix_articles_controller"
application.register("trix-articles", TrixArticlesController)

import TrixAttachmentsController from "./trix_attachments_controller"
application.register("trix-attachments", TrixAttachmentsController)

import TrixDisableAttachmentController from "./trix_disable_attachment_controller"
application.register("trix-disable-attachment", TrixDisableAttachmentController)

import UppyController from "./uppy_controller"
application.register("uppy", UppyController)
